import React, { useMemo, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import { CreaSede } from "../../Services/Rest";

ReactModal.setAppElement("#root");

const AUTH = {
  username: "BasicAuth@icontec.org",
  password: "yQLzqmR7eZSuAmQZUqhY",
};

const initialForm = {
  nombre: "",
  direccion: "",
  nombreContacto: "",
  numeroContacto: "",
  fechaAcreditacion: "",
  fechaRenovacion: "",
  codigoPrestadorSede: "",
  especialidad: "",
  justificacion: "",
};

function CrearSede({ onCreated }) {
  const cookies = useMemo(() => new Cookies(), []);

  const tipoUsuario = Number(cookies.get("tipo_Usuario"));
  const institucionId = cookies.get("institucionid");

  const esAdministrador = tipoUsuario === 1;

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [formData, setFormData] = useState(initialForm);
  const [loading, setLoading] = useState(false);

  /**
   * ======================================================
   * ABRIR MODAL
   * ======================================================
   */
  const abrirModal = () => {
    setFormData(initialForm);
    setModalIsOpen(true);
  };

  /**
   * ======================================================
   * CERRAR MODAL
   * ======================================================
   */
  const cerrarModal = () => {
    if (loading) return;

    setModalIsOpen(false);
    setFormData(initialForm);
  };

  /**
   * ======================================================
   * MANEJO DE INPUTS
   * ======================================================
   */
  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /**
   * ======================================================
   * CREAR SEDE
   * ======================================================
   */
  const crearSede = async (event) => {
    event.preventDefault();

    if (!formData.nombre.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Campo requerido",
        text: "Debe ingresar el nombre de la sede.",
      });
      return;
    }

    if (!formData.direccion.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Campo requerido",
        text: "Debe ingresar la dirección de la sede.",
      });
      return;
    }

    if (!formData.nombreContacto.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Campo requerido",
        text: "Debe ingresar el nombre de la persona de contacto.",
      });
      return;
    }

    if (!formData.numeroContacto.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Campo requerido",
        text: "Debe ingresar el número de contacto.",
      });
      return;
    }

    if (!formData.justificacion.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Campo requerido",
        text: "Debe ingresar una justificación para la creación de la sede.",
      });
      return;
    }

    if (!institucionId) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No fue posible identificar la institución.",
      });
      return;
    }

    setLoading(true);

    try {
      const payload = {
        nombre: formData.nombre.trim(),
        especialidad: formData.especialidad || "",
        direccion: formData.direccion.trim(),
        nombreContacto: formData.nombreContacto.trim(),
        numeroContacto: formData.numeroContacto.trim(),
        institucionId: Number(institucionId),
        fechaAcreditacion: esAdministrador ? formData.fechaAcreditacion : "",
        fechaRenovacion: esAdministrador ? formData.fechaRenovacion : "",
        codigoPrestadorSede: formData.codigoPrestadorSede.trim(),
        justificacion: formData.justificacion.trim(),
      };

      await axios.post(CreaSede, payload, {
        auth: AUTH,
      });

      await Swal.fire({
        icon: "success",
        title: "Sede creada correctamente",
        text: "La sede fue registrada exitosamente.",
        timer: 2000,
        showConfirmButton: false,
      });

      cerrarModal();

      /**
       * Permite actualizar la tabla sin recargar toda la página
       */
      if (onCreated) {
        onCreated();
      }
    } catch (error) {
      console.error("Error creando sede:", error);

      Swal.fire({
        icon: "error",
        title: "No fue posible crear la sede",
        text:
          error?.response?.data?.message ||
          "Verifique la información e intente nuevamente.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* ==================================================
          BOTÓN NUEVA SEDE
      ================================================== */}

      <button type="button" className="btn btn-primary" onClick={abrirModal}>
        <i className="fas fa-plus mr-2" />
        Nueva sede
      </button>

      {/* ==================================================
          MODAL
      ================================================== */}

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={cerrarModal}
        shouldCloseOnOverlayClick={!loading}
        shouldCloseOnEsc={!loading}
        contentLabel="Crear nueva sede"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.65)",
            zIndex: 9999,
          },

          content: {
            maxWidth: "950px",
            width: "95%",
            maxHeight: "90vh",
            margin: "auto",
            padding: 0,
            border: "none",
            borderRadius: "12px",
            overflow: "auto",
          },
        }}
      >
        <div className="card border-0 shadow-lg mb-0">
          {/* ==================================================
              HEADER
          ================================================== */}

          <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
            <div>
              <h5 className="mb-0 font-weight-bold">Nueva sede</h5>

              <small>
                Complete la información para registrar una nueva sede
              </small>
            </div>

            <button
              type="button"
              className="btn btn-sm btn-light"
              onClick={cerrarModal}
              disabled={loading}
            >
              ✕
            </button>
          </div>

          {/* ==================================================
              FORMULARIO
          ================================================== */}

          <form onSubmit={crearSede}>
            <div className="card-body">
              {/* INFORMACIÓN GENERAL */}

              <h6 className="text-primary font-weight-bold mb-3">
                Información general
              </h6>

              <div className="form-row">
                {/* NOMBRE */}

                <div className="form-group col-md-6">
                  <label className="font-weight-bold">Nombre de la sede</label>

                  <input
                    type="text"
                    name="nombre"
                    className="form-control"
                    placeholder="Ingrese el nombre de la sede"
                    value={formData.nombre}
                    onChange={handleChange}
                    disabled={loading}
                    required
                  />
                </div>

                {/* CÓDIGO */}

                <div className="form-group col-md-6">
                  <label className="font-weight-bold">Código prestador</label>

                  <input
                    type="text"
                    name="codigoPrestadorSede"
                    className="form-control"
                    placeholder="Ingrese el código del prestador"
                    value={formData.codigoPrestadorSede}
                    onChange={handleChange}
                    disabled={loading}
                  />
                </div>
              </div>

              {/* DIRECCIÓN */}

              <div className="form-group">
                <label className="font-weight-bold">Dirección</label>

                <input
                  type="text"
                  name="direccion"
                  className="form-control"
                  placeholder="Ingrese la dirección completa"
                  value={formData.direccion}
                  onChange={handleChange}
                  disabled={loading}
                  required
                />
              </div>

              <hr />

              {/* CONTACTO */}

              <h6 className="text-primary font-weight-bold mb-3">
                Información de contacto
              </h6>

              <div className="form-row">
                {/* PERSONA CONTACTO */}

                <div className="form-group col-md-6">
                  <label className="font-weight-bold">
                    Persona de contacto
                  </label>

                  <input
                    type="text"
                    name="nombreContacto"
                    className="form-control"
                    placeholder="Nombre de la persona de contacto"
                    value={formData.nombreContacto}
                    onChange={handleChange}
                    disabled={loading}
                    required
                  />
                </div>

                {/* TELÉFONO */}

                <div className="form-group col-md-6">
                  <label className="font-weight-bold">Número de contacto</label>

                  <input
                    type="text"
                    name="numeroContacto"
                    className="form-control"
                    placeholder="Número telefónico"
                    value={formData.numeroContacto}
                    onChange={handleChange}
                    disabled={loading}
                    required
                  />
                </div>
              </div>

              <hr />

              {/* JUSTIFICACIÓN */}

              <h6 className="text-primary font-weight-bold mb-3">
                Justificación
              </h6>

              <div className="form-group">
                <label className="font-weight-bold">
                  Motivo o justificación de la sede
                </label>

                <textarea
                  name="justificacion"
                  className="form-control"
                  rows="4"
                  placeholder="Describa la justificación para la creación de esta sede..."
                  value={formData.justificacion}
                  onChange={handleChange}
                  disabled={loading}
                  required
                />

                <small className="form-text text-muted">
                  Explique brevemente el motivo de creación o registro de la
                  sede.
                </small>
              </div>

              {/* ==================================================
                  CAMPOS ADMINISTRADOR
              ================================================== */}

              {esAdministrador && (
                <>
                  <hr />

                  <h6 className="text-primary font-weight-bold mb-3">
                    Información de acreditación
                  </h6>

                  <div className="form-row">
                    {/* FECHA ACREDITACIÓN */}

                    <div className="form-group col-md-6">
                      <label className="font-weight-bold">
                        Fecha de acreditación
                      </label>

                      <input
                        type="date"
                        name="fechaAcreditacion"
                        className="form-control"
                        value={formData.fechaAcreditacion}
                        onChange={handleChange}
                        disabled={loading}
                      />
                    </div>

                    {/* FECHA RENOVACIÓN */}

                    <div className="form-group col-md-6">
                      <label className="font-weight-bold">
                        Fecha de renovación
                      </label>

                      <input
                        type="date"
                        name="fechaRenovacion"
                        className="form-control"
                        value={formData.fechaRenovacion}
                        onChange={handleChange}
                        disabled={loading}
                      />
                    </div>
                  </div>

                  {/* ESTADO ACREDITACIÓN */}

                  <div className="form-group">
                    <label className="font-weight-bold">
                      Estado de acreditación
                    </label>

                    <select
                      name="especialidad"
                      className="form-control"
                      value={formData.especialidad}
                      onChange={handleChange}
                      disabled={loading}
                    >
                      <option value="">Seleccione una opción</option>

                      <option value="Si">Sí, está acreditada</option>

                      <option value="No">No está acreditada</option>
                    </select>
                  </div>
                </>
              )}
            </div>

            {/* ==================================================
                FOOTER
            ================================================== */}

            <div className="card-footer bg-light d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-secondary mr-2"
                onClick={cerrarModal}
                disabled={loading}
              >
                Cancelar
              </button>

              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm mr-2"
                      role="status"
                    />
                    Guardando...
                  </>
                ) : (
                  <>
                    <i className="fas fa-save mr-2" />
                    Guardar sede
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </ReactModal>
    </div>
  );
}

export default CrearSede;
